import { default as Budget } from "./Budget";
import { default as OurWork } from "./OurWork";
import { default as ProfitEstimate } from "./ProfitEstimate";
import { default as ProgressChange } from "./ProgressChange";
import { default as RowActions } from "./RowActions";
import { default as SubmitProgress } from "./SubmitProgress";
import { default as SubRowActions } from "./SubRowActions";

export default {
  Budget,
  OurWork,
  ProgressChange,
  ProfitEstimate,
  SubmitProgress,
  RowActions,
  SubRowActions,
};
